import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import '@angular/compiler';

import { AppModule } from './app/app.module';
import { environmentConfigs } from './environments/environment-config';
import { getAppDomain, getEnvironmentIdentifier } from './environments/get-environment-identifier';

const identifier = getEnvironmentIdentifier();
const baseEnvironment = environmentConfigs[identifier] || environmentConfigs['dev'];
const environment = {
  ...baseEnvironment,
  AppDomain: getAppDomain(identifier),
};

// تعيين البيئة في window object للوصول إليها من أي مكان
(window as any).environment = environment;

if (environment.production) {
  enableProdMode();
}

console.log(`Starting application with environment: ${identifier}`);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
